module.exports = __webpack_public_path__ + "img/artificial_intelligence_flatline2.40def0b8.svg";